import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchBar from "@/components/feature/SearchBar";

interface Slide {
  id: string;
  title: string;
  tagline: string;
  image: string;
}

const slides: Slide[] = [
  {
    id: "m1",
    title: "星际方舟",
    tagline: "人类最后的方舟，驶向未知星系的宇宙远征",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20massive%20ark%20spaceship%20gliding%20past%20a%20glowing%20blue%20nebula%20in%20deep%20space%2C%20epic%20sci-fi%20atmosphere%2C%20dark%20dramatic%20lighting%2C%20highly%20detailed%20film%20still&width=1600&height=900&seq=ccvideo-hero-1&orientation=landscape",
  },
  {
    id: "t2",
    title: "悬镜",
    tagline: "每一面镜子的背后，都藏着无人知晓的真相",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20crime%20drama%20scene%20of%20a%20rainy%20city%20street%20at%20night%20with%20a%20single%20detective%20silhouette%2C%20moody%20deep%20blue%20and%20amber%20lighting%2C%20suspenseful%20cinematic%20film%20still&width=1600&height=900&seq=ccvideo-hero-2&orientation=landscape",
  },
  {
    id: "v3",
    title: "音乐无界",
    tagline: "跨越风格边界的舞台，让每一种声音都被听见",
    image:
      "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20a%20singer%20silhouette%20under%20a%20warm%20spotlight%2C%20glowing%20particles%20and%20crowd%20lights%2C%20dramatic%20blue%20and%20gold%20stage%20lighting%2C%20cinematic%20music%20live%20scene&width=1600&height=900&seq=ccvideo-hero-3&orientation=landscape",
  },
  {
    id: "m5",
    title: "极限营救",
    tagline: "在风暴来临之前，完成一场不可能的营救",
    image:
      "https://readdy.ai/api/search-image?query=High%20octane%20action%20scene%20of%20a%20helicopter%20flying%20over%20a%20burning%20mountain%20road%20at%20dusk%2C%20explosive%20orange%20fire%20against%20steel%20blue%20sky%2C%20cinematic%20blockbuster%20film%20still&width=1600&height=900&seq=ccvideo-hero-4&orientation=landscape",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden bg-primary-950">
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 焦点推荐`}
            title={`${slide.title} - CC视频精选推荐`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-primary-950/30"></div>

      <div className="relative h-full max-w-content mx-auto px-4 md:px-6 flex flex-col justify-center">
        <p className="text-accent-300 text-sm md:text-base font-medium tracking-wide">
          精选影视 · 资讯速递
        </p>
        <h1 className="mt-3 text-3xl md:text-5xl font-heading font-bold text-white leading-tight">
          CC视频 · 精选影视视频内容平台
        </h1>
        <p className="mt-4 text-base md:text-lg text-white/80 max-w-2xl">
          聚合电影、电视剧、综艺三大频道与最新影视资讯，快速发现你想看的每一部作品。
        </p>

        <div className="mt-6 max-w-xl">
          <SearchBar size="lg" />
        </div>

        <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="text-white">
            <p className="text-xs text-white/70">当前焦点</p>
            <Link
              to={`/detail/${slides[index].id}`}
              className="text-lg md:text-xl font-heading font-bold hover:text-accent-300 transition-colors cursor-pointer inline-flex items-center gap-2"
            >
              {slides[index].title}
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
            <p className="text-sm text-white/70 mt-0.5">{slides[index].tagline}</p>
          </div>

          <div className="flex items-center gap-2 sm:ml-auto">
            {slides.map((slide, i) => (
              <button
                key={slide.id}
                type="button"
                aria-label={`切换到第${i + 1}张`}
                onClick={() => setIndex(i)}
                className={`rounded-full transition-all cursor-pointer ${
                  i === index ? "w-8 h-2 bg-accent-500" : "w-2 h-2 bg-white/50 hover:bg-white/80"
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}